export const HANDLE_FETCH_CURRENT_LOCATION = "HANDLE_FETCH_CURRENT_LOCATION";
export interface IHandleFetchCurrentLocation {
  type: typeof HANDLE_FETCH_CURRENT_LOCATION;
}

export const HANDLE_FETCH_LOCATIONS = "HANDLE_FETCH_LOCATIONS";
export interface IHandleFetchLocations {
  type: typeof HANDLE_FETCH_LOCATIONS;
}

export const HANDLE_FETCH_LOCATION = "HANDLE_FETCH_LOCATION";
export interface IHandleFetchLocation {
  type: typeof HANDLE_FETCH_LOCATION;
  payload: {
    locationId: string;
  };
}

export const HANDLE_UPDATE_LOCATION = "HANDLE_UPDATE_LOCATION";
export interface IHandleUpdateLocation {
  type: typeof HANDLE_UPDATE_LOCATION;
  payload: {
    location: TLocation;
  };
}

export const HANDLE_UPDATE_LOCATION_INFO = "HANDLE_UPDATE_LOCATION_INFO";
export interface IHandleUpdateLocationInfo {
  type: typeof HANDLE_UPDATE_LOCATION_INFO;
  payload: {
    locationInfo: LocationRequest;
  };
}

export const HANDLE_UPDATE_LOCATION_BRANDING = "HANDLE_UPDATE_LOCATION_BRANDING";

export interface IHandleUpdateLocationBranding {
  type: typeof HANDLE_UPDATE_LOCATION_BRANDING;
  payload: {
    body: UpdateLocationBrandingRequest;
  };
}

export const HANDLE_CREATE_BRANDING = "HANDLE_CREATE_BRANDING";
export interface IHandleCreateBranding {
  type: typeof HANDLE_CREATE_BRANDING;
  payload: {
    branding: FormData;
    locationId?: string;
  };
}

export const HANDLE_UPDATE_BRANDING = "HANDLE_UPDATE_BRANDING";

export interface IHandleUpdateBranding {
  type: typeof HANDLE_UPDATE_BRANDING;
  payload: {
    newBranding: FormData;
  };
}

export const HANDLE_CREATE_LOCATION = "HANDLE_CREATE_LOCATION";

export interface IHandleCreateLocation {
  type: typeof HANDLE_CREATE_LOCATION;
  payload: {
    location: Partial<TLocation>;
  };
}

export const SET_ACTIVE_LOCATION = "SET_ACTIVE_LOCATION";

export interface ISetActiveLocation {
  type: typeof SET_ACTIVE_LOCATION;
  payload: {
    location: TLocation;
  };
}

export const HANDLE_UPDATE_LOCATION_SUBDOMAIN = "HANDLE_UPDATE_LOCATION_SUBDOMAIN";

export interface IHandleUpdateLocationSubdomain {
  type: typeof HANDLE_UPDATE_LOCATION_SUBDOMAIN;
  payload: {
    body: UpdateLocationSubdomainRequest;
  };
}

export const HANDLE_FETCH_ACTIVE_LOCATION_SUMMARY = "HANDLE_FETCH_ACTIVE_LOCATION_SUMMARY";

export interface IHandleFetchActiveLocationSummary {
  type: typeof HANDLE_FETCH_ACTIVE_LOCATION_SUMMARY;
  payload: {
    locationId: string;
  };
}

export const SET_ALL_LOCATIONS = "SET_ALL_LOCATIONS";
export interface ISetAllLocation {
  type: typeof SET_ALL_LOCATIONS;
  payload: {
    locations: TLocation[];
  };
}

export const SET_CURRENT_LOCATION = "SET_CURRENT_LOCATION";
export interface ISetCurrentLocation {
  type: typeof SET_CURRENT_LOCATION;
  payload: {
    location: TLocation;
  };
}

export const SET_ACTIVE_LOCATION_SUMMARY = "SET_ACTIVE_LOCATION_SUMMARY";

export interface ISetActiveLocationSummary {
  type: typeof SET_ACTIVE_LOCATION_SUMMARY;
  payload: {
    locationSummary;
  };
}

export const SET_LOCATIONS_SIMPLIFIED_LOADING = "SET_LOCATIONS_SIMPLIFIED_LOADING";

export interface ISetLocationsSimplifiedLoading {
  type: typeof SET_LOCATIONS_SIMPLIFIED_LOADING;
  payload: {
    isLoading: boolean;
  };
}
